import { apiDelete, apiGet, apiPatch, apiPost } from './client';
import type { PaginatedResponse } from './users';

export interface ConsoleGroup {
  id: number;
  name: string;
  permission_codenames: string[];
  user_count: number;
}

export async function list(params: { search?: string } = {}): Promise<PaginatedResponse<ConsoleGroup>> {
  const usp = new URLSearchParams();
  if (params.search) usp.set('search', params.search);
  const qs = usp.toString();
  return apiGet(`/groups/${qs ? `?${qs}` : ''}`);
}

export async function retrieve(id: number): Promise<ConsoleGroup> {
  return apiGet(`/groups/${id}/`);
}

export async function create(name: string, permissionCodenames: string[]): Promise<ConsoleGroup> {
  return apiPost('/groups/', { name, permission_codenames: permissionCodenames });
}

export async function update(
  id: number,
  body: { name?: string; permission_codenames?: string[] },
): Promise<ConsoleGroup> {
  return apiPatch(`/groups/${id}/`, body);
}

export async function remove(id: number): Promise<void> {
  await apiDelete<void>(`/groups/${id}/`);
}
